var text = "\
;                   _     _                            _                 _         \r\n\
;                  | |   | |                          | |               (_)        \r\n\
;   _ __     __ _  | |_  | |_   _   _    ___    __ _  | | __   ___       _    ___  \r\n\
;  | '_ \\   / _` | | __| | __| | | | |  / __|  / _` | | |/ /  / _ \\     | |  / _ \\ \r\n\
;  | |_) | | (_| | | |_  | |_  | |_| | | (__  | (_| | |   <  |  __/  _  | | | (_) |\r\n\
;  | .__/   \\__,_|  \\__|  \\__|  \\__, |  \\___|  \\__,_| |_|\\_\\  \\___| (_) |_|  \\___/ \r\n\
;  | |                           __/ |                                             \r\n\
;  |_|                          |___/                                              \r\n\
";
text += ';\r\n';

text += '; Create your own .pat files with real-time editing and preview at https://pattycake.io\r\n';

export default text;


// WEBPACK FOOTER //
// ./src/pattern_utilities/patternWatermark.js